/**
 * specialNodes 存放一些特殊节点，如 gamePlay
 */
export const specialNodes = {
  gamePlay: {
    name: 'gamePlay'
  }
}
